import React from 'react';
import Layout from '../layout';
import CustomizationProcess from '../components/CustomizationProcess/index.jsx';
import HowItWorks from '../components/HowItWorks/index';
import SEO from '../components/SEO/index.jsx';

const CustomizationProcessPage = () => (
  <Layout>
    <SEO
      title="Customization Process - Greek Dressing"
      description="We make ordering custom apparel for your organization easy. We offer online group ordering, free mockups from our designers, and rapidly fast delivery!"
    />
    <HowItWorks />
    {/* <CustomizationProcess /> */}
  </Layout>
);

export default CustomizationProcessPage;
